import { globalVariables } from "helper/globalVariables";
import Layout from "shared/Layout";
import { useEffect, useState } from "react";
import TitalAnalytics from "./Tabs/TitalAnalytics";
import TrialAnalytics from "./Tabs/TrialAnalytics";
import { Button } from "shared/Components/button";
import Loader from "shared/Components/loader";
import { downloadCloud } from "helper/icons";
import TabHeader from "./Tabs/TabHeader";
import {
  GET_ALL_TITLE_ANALYTICS,
  GET_TRIAL_ANALYTICS,
  GET_TRIAL_FOR_ADMIN_ANALYTICS,
  GET_ALL_TITLE_FOR_ADMIN_ANALYTICS,
  GET_ALL_FOR_HOST_ADMIN_TITLES,
} from "redux/features/hostDashboardSlice/hostDashboardApi";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import MultiSelectWithSearch from "shared/Components/multiSelectWithSearch";
import {
  generateTitleAnalytic,
  generateTrialAnalytic,
  generatePassRateReportFull,
} from "redux/features/reports/reportsGql";
import { client } from "helper/apolloConfig";
import PageInfo from "shared/Components/pageInfo";
import ScrollToTop from "shared/Components/scrollToTop";

const DownloadTitleReport = () => {
  const [loading, setLoading] = useState(false);

  const onDownload = async () => {
    setLoading(true);
    const result = await client.query({
      query: generateTitleAnalytic,
    });
    const data = result?.data?.getAllTitleAnalyticsForHostDashboardPdf;
    window.open(data?.pdfUrl, "_blank");
    setLoading(false);
  };

  return (
    <div className="w-full mt-[10px] md:mt-[0px] md:w-[150px] md:ml-[10px]">
      <Button
        width="w-full"
        label={globalVariables.download}
        icon={downloadCloud}
        prefix={false}
        disabled={loading}
        onClick={onDownload}
      />
    </div>
  );
};

const DownloadTrialReport = () => {
  const [loading, setLoading] = useState(false);

  const onDownload = async () => {
    setLoading(true);
    const result = await client.query({
      query: generateTrialAnalytic,
    });
    const data = result?.data?.generateTrialStatisticsReport;
    window.open(data?.downloadUrl, "_blank");
    setLoading(false);
  };

  return (
    <div className="w-full mt-[10px] md:mt-[0px] md:w-[150px] md:ml-[10px]">
      <Button
        width="w-full"
        label={globalVariables.download}
        icon={downloadCloud}
        prefix={false}
        disabled={loading}
        onClick={onDownload}
      />
    </div>
  );
};

const DownloadPassRateReport = () => {
  const [loading, setLoading] = useState(false);

  const onDownload = async () => {
    setLoading(true);
    const result = await client.query({
      query: generatePassRateReportFull,
    });
    const data = result?.data?.generatePassRateReportFull;
    window.open(data?.downloadUrl, "_blank");
    setLoading(false);
  };

  return (
    <div className="w-full mt-[10px] md:mt-[0px] md:w-[150px] md:ml-[10px]">
      <Button
        width="w-full"
        label={globalVariables.passRate}
        icon={downloadCloud}
        prefix={false}
        disabled={loading}
        onClick={onDownload}
      />
    </div>
  );
};

const SuperAdminDashboard = () => {
  const role = useSelector((state) => state.auth.authReducer.role);
  const [searchContainersData, setSearchContainersData] = useState([]);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const titleQuery =
    role === "Super Admin"
      ? GET_ALL_TITLE_FOR_ADMIN_ANALYTICS
      : GET_ALL_TITLE_ANALYTICS;
  const trialQuery =
    role === "Super Admin"
      ? GET_TRIAL_FOR_ADMIN_ANALYTICS
      : GET_TRIAL_ANALYTICS;
  const { loading: titleLoading, data: titleAnalytics } = useQuery(titleQuery, {
    variables: { search: search },
  });
  const { data: trialAnalytics } = useQuery(trialQuery);
  const { data: list } = useQuery(GET_ALL_FOR_HOST_ADMIN_TITLES);
  
  useEffect(() => {
    if (list && list.getAllTitles) {
      const searchContainers = list.getAllTitles.map((e) => ({
        label: e.search,
      }));
      setSearchContainersData(searchContainers);
    }
  }, [list]);

  const onChangeSearchName = (value) => {
    if (value === "") {
      setSearch(value);
    } else setSearch(value.label);
  };

 
  if (titleAnalytics?.length < 1 || titleLoading) { 
    return (
      <div
        className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}
      >
        <PageInfo title={globalVariables.dogHistory} />
        <div className="h-[70vh] flex justify-center items-center text-center mt-4">
          {titleLoading ? (
            <Loader />
          ) : (
            <span className="text-base font-semibold">
              {globalVariables.noDataAvailable}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <ScrollToTop />
      <PageInfo title={globalVariables.analytics}/>
      <div className="mt-[20px] flex flex-wrap justify-between">
        <div className="flex w-max max-[380px]:w-[100%] max-[380px]:justify-center">
          <TabHeader
            onClick={() => setActiveTab(0)}
            heading={globalVariables.titleAnalytics}
            isActive={activeTab === 0}
          />
          <TabHeader
            onClick={() => setActiveTab(1)}
            heading={globalVariables.trialAnalytics}
            isActive={activeTab === 1}
            customCss={"ml-5 max-[380px]:ml-[35px]"}
          />
        </div>
        <div className="flex flex-wrap mt-[20px] w-[100%] md:w-max md:mt-[0px]">
          {activeTab === 0 ? (
            <>
              <div>
                <MultiSelectWithSearch
                  options={searchContainersData}
                  placeholder={globalVariables.selectTitle}
                  showCross
                  width="lg:w-[200px] w-[318px]"
                  onChange={(selectedOptions) => {
                    onChangeSearchName(selectedOptions[0]);
                  }}
                  onClear={() => onChangeSearchName("")}
                />
              </div>
              <DownloadTitleReport />
            </>
          ) : (
            <>
              <div>
                {/* <MultiSelectWithSearch
                  options={searchContainersData}
                  placeholder={globalVariables.selectTitle}
                  showCross
                  width="lg:w-[200px] w-[318px]"
                  onChange={(selectedOptions) => {
                    onChangeSearchName(selectedOptions[0]);
                  }}
                  onClear={() => onChangeSearchName("")}
                /> */}
              </div>
              <DownloadPassRateReport />
              <DownloadTrialReport />
            </>
          )}
        </div>
      </div>
      {role === "Super Admin" ? (
        <>
          {activeTab === 0 && (
            <TitalAnalytics
              TitleAnalyticsData={titleAnalytics?.getAllTitleAnalyticsDashboard}
              loading={titleLoading}
            />
          )}
          {activeTab === 1 && (
            <TrialAnalytics
              TrialAnalyticsData={trialAnalytics?.getTrialAnalyticsForDashbaord}
            />
          )}
        </>
      ) : (
        <>
          {activeTab === 0 && (
            <TitalAnalytics
              TitleAnalyticsData={
                titleAnalytics?.getAllTitleAnalyticsForHostDashboard
              }
              loading={titleLoading}
            />
          )}
          {activeTab === 1 && (
            <TrialAnalytics
              TrialAnalyticsData={
                trialAnalytics?.getTrialAnalyticsForHostDashboard
              }
            />
          )}
        </>
      )}
    </div>
  );
};
export default SuperAdminDashboard;
